import get from "lodash/get";
import _app from "Pages/_app";
import { Component } from "react";
import { connect, DispatchProp } from "react-redux";
import { updateCartMutation } from "Utils/api/gql/mutations/updateCart";
import {
  CartFragment,
  getCheckoutInfo_shippingMethods,
  getCheckoutInfo_shippingMethods_ShippingMethodGPoint,
  getCheckoutInfo_shippingMethods_ShippingMethodGRoby,
  getCheckoutInfo_shippingMethods_ShippingMethodMpl,
  getCheckoutInfo_shippingMethods_ShippingMethodPostPoint,
  updateCart,
  updateCartVariables
} from "Utils/api/gql/types";
import CheckoutHelper from "Utils/helpers/checkoutHelper";
import { parseErrors } from "Utils/helpers/errorHelper";
import { showMessage } from "Utils/helpers/modalHelper";
import { setCart } from "Utils/redux/actions";
import Form from "Components/Form";
import Input from "Components/Input";

import cn from "classnames";
import cg from "Scss/app.scss";
import Accordion from "Components/Accordion";
import cl from "Scss/pages/cart.scss";
import { SVGTrashSmall } from "./SVGCollection";
import Button from "Components/Button";

import btnCss from "Components/Button/Button.scss";

type ReduxProps = {
  cart: CartFragment | null;
};

type Props = {
  shippingMethodNameSelected?: Redux.ShippingMethodCode | null;
  shippingMethodsAvailable?: getCheckoutInfo_shippingMethods[];
} & ReduxProps &
  DispatchProp;

type State = {
  coupon: string;
  couponError: string;
};

type availableShippingMethodsType =
  | getCheckoutInfo_shippingMethods_ShippingMethodGPoint
  | getCheckoutInfo_shippingMethods_ShippingMethodMpl
  | getCheckoutInfo_shippingMethods_ShippingMethodGRoby
  | getCheckoutInfo_shippingMethods_ShippingMethodPostPoint;

function getAvailableShippingMethodByMethodName<
  T extends availableShippingMethodsType
>(
  methodName: T["__typename"],
  shippingMethods: availableShippingMethodsType[]
): T | null {
  const found = shippingMethods.find(item => item.__typename === methodName);
  if (found && found.__typename === methodName) {
    return found as T;
  }
  return null;
}

export class CartCoupon extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      coupon: "",
      couponError: ""
    };
  }

  updateCouponCode = async () => {
    const { cart } = this.props;
    if (!cart || !this.state.coupon) return;

    let selectedMethodId: string | undefined = undefined;
    if (
      this.props.shippingMethodNameSelected &&
      this.props.shippingMethodsAvailable
    ) {
      const selectedMethod = this.props.shippingMethodNameSelected
        ? getAvailableShippingMethodByMethodName(
            this.props.shippingMethodNameSelected,
            this.props.shippingMethodsAvailable
          )
        : null;

      if (selectedMethod && CheckoutHelper.methodHasAnyError(selectedMethod)) {
        showMessage(
          "A kosarad a megadott szállítási mód tömegkorlátját meghaladja, vagy az adott szállítási móddal nem rendelhető terméket tartalmaz. A kuponkód érvényesítéséhez kérünk, előbb módosítsd a kosarad vagy a szállítási módot!"
        );
        return;
      }
      selectedMethodId = !!selectedMethod ? selectedMethod.id : undefined;
    }

    try {
      const result = await _app.apolloClient.mutate<
        updateCart,
        updateCartVariables
      >({
        mutation: updateCartMutation,
        variables: {
          input: {
            id: cart.id,
            shipping_method_id: selectedMethodId,
            coupon_code: this.state.coupon
          }
        }
      });

      if (result.data && result.data.updateCart) {
        showMessage("Kuponkódodat érvényesítettük!");
        this.props.dispatch(setCart(result.data.updateCart));
        this.setState({ couponError: "" });
      }
    } catch (e) {
      const couponError = get(
        e,
        "graphQLErrors.0.extensions.validation.input.coupon_code.0"
      );
      if (couponError) {
        this.setState({ couponError });
      } else {
        const parsed = parseErrors(e);
        this.setState({
          couponError: parsed.general || "Ismeretlen hiba történt"
        });
      }
    }
  };

  deleteCoupon = async () => {
    try {
      const result = await _app.apolloClient.mutate<
        updateCart,
        updateCartVariables
      >({
        mutation: updateCartMutation,
        variables: {
          input: {
            id: this.props.cart!.id,
            coupon_code: null
          }
        }
      });
      if (result.data && result.data.updateCart) {
        this.props.dispatch(setCart(result.data.updateCart));
      }
    } catch (e) {
      showMessage("Hiba történt a kupon törlése közben!");
    }
  };

  render() {
    const cart = this.props.cart;
    if (!cart) {
      return null;
    }
    return (
      <Accordion
        ariaId="TODO"
        ariaLevel={2}
        defaultOpened={cart.coupon_code !== null}
        renderHeader={<h2 style={{ marginLeft: "10px" }}>Kuponkód megadása</h2>}
      >
        <div className={cn(cl.accordionText)}>
          <p>
            Itt írhatod be a kuponkódod, hogy azonnal érvényesíthessük a
            kedvezményedet.
          </p>

          <Form>
            <fieldset>
              <div
                className={cn(cg.gridX, cg.textCenter, cg.mediumTextLeft)}
                style={{ marginBottom: "20px" }}
              >
                <div className={cn(cg.cell, cg.medium5)}>
                  <Input
                    name="coupon"
                    label="Kuponkód"
                    type="text"
                    placeholder="Kuponkód"
                    onChange={({ currentTarget: { value } }) => {
                      this.setState({ coupon: value, couponError: "" });
                    }}
                    value={cart.coupon_code || this.state.coupon}
                    disabled={!!cart.coupon_code}
                    error={this.state.couponError}
                    hideLabel
                    noMargin
                  />
                </div>

                <div className={cn(cg.cell, cg.small12, cg.medium2)}>
                  {!cart.coupon_code ? (
                    <Button
                      className={cn(btnCss.secondary, cg.mediumNoMargin)}
                      label="Érvényesít"
                      onClick={this.updateCouponCode}
                    />
                  ) : (
                    <Button
                      className={cn(btnCss.delete, cg.mediumNoMargin)}
                      style={{ whiteSpace: "nowrap" }}
                      label="Kuponkód törlése"
                      onClick={this.deleteCoupon}
                      renderIcon={{
                        Icon: <SVGTrashSmall width={22} height={22} />,
                        ariaLabel: "Kuponkód törlése",
                        alignIcon: "left"
                      }}
                    />
                  )}
                </div>
                <div
                  className={cn(
                    cg.cell,
                    cg.small12,
                    cg.medium5,
                    cg.mediumTextRight
                  )}
                >
                  &nbsp;
                </div>
              </div>
            </fieldset>
          </Form>
        </div>
      </Accordion>
    );
  }
}

const mapStateToProps = (state: Redux.IReduxState): ReduxProps => {
  return {
    cart: state.cart
  };
};

export default connect(mapStateToProps)(CartCoupon);
